// Native
import { Box, Button, ButtonGroup, DialogBody, DialogFooter, Flex, HStack, IconButton, Image, Separator, Stack, Text } from "@chakra-ui/react"
import { useNavigate } from "react-router"
import OneSignal from "react-onesignal"

// Custom
import { useColorMode } from "components/ui-old/color-mode"
import { UI } from "components"
import { useData } from "hooks/useData"
import useDistributor from "hooks/useDistributor"
import { useState, useEffect } from "react"
import { toaster } from "config"
import { API } from "config"

// Adicione entradas aqui para publicar novos comunicados
const ANNOUNCEMENTS = [
    { id: 'comunicado_forma_pagamentos', image: '/comunicado_forma_pagamentos.jpeg', title: 'Comunicado: Formas de Pagamento' },
]

const SEEN_KEY = '@announcements_seen'
const getSeenIds = () => { try { return JSON.parse(localStorage.getItem(SEEN_KEY)) ?? [] } catch { return [] } }
const persistSeen = id => { const s = getSeenIds(); if (!s.includes(id)) localStorage.setItem(SEEN_KEY, JSON.stringify([...s, id])) }

export default function Header({ title, hiddenAlerts, ...props }){

    const navigate = useNavigate()
    const colorMode = useColorMode()
    const { toggleDrawer } = useData()
    const distributor = useDistributor()

    const [announcement, setAnnouncement] = useState(null)
    const [hasUnread, setHasUnread] = useState(() => ANNOUNCEMENTS.some(a => !getSeenIds().includes(a.id)))

    const openAnnouncement = (item) => {
        persistSeen(item.id)
        setHasUnread(ANNOUNCEMENTS.some(a => !getSeenIds().includes(a.id)))
        setAnnouncement(item)
    }

    useEffect(() => {
        const first = ANNOUNCEMENTS.find(a => !getSeenIds().includes(a.id))
        if (!first) return
        const t = setTimeout(() => openAnnouncement(first), 700)
        return () => clearTimeout(t)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleBellClick = () => {
        const unread = ANNOUNCEMENTS.find(a => !getSeenIds().includes(a.id))
        openAnnouncement(unread ?? ANNOUNCEMENTS[0])
    }

    const handleLogout = async () => {
        if(!window.confirm('Tem certeza que deseja sair?')) return

        try {
            // ⚠️ CORREÇÃO:
            // O erro estava acontecendo porque o logout do OneSignal era chamado
            // mesmo quando não havia usuário inicializado internamente.
            // Agora só faço logout se existir um usuário válido.
            if (OneSignal?.User?.externalId) {
                await OneSignal.logout()
            }
        } catch (err) {
            // Se o OneSignal não estiver pronto, apenas ignoro
            console.warn('Logout do OneSignal ignorado:', err)
        }

        navigate('/')
        localStorage.clear()
        window.location.reload()
    }

    return(
    <>

    <Box w="100%" py={4} borderBottomWidth={1} mb={4} {...props}>
        <Flex justifyContent="space-between">

            <HStack alignItems="center">
                <IconButton hideFrom="lg" variant="ghost" onClick={toggleDrawer}><UI.Icon name="menu" /></IconButton>
                <Image hideFrom="lg" src="/icon.png" h="30px" />
                <Text children={title} fontSize={{ base: 'lg', sm: 'lg', md: '2xl', lg: '2xl' }} />
            </HStack>

            <Box></Box>

            <Box>
                <ButtonGroup>
                    <Box position="relative" display="inline-flex">
                        <IconButton
                            size="xs"
                            variant="ghost"
                            colorPalette={hasUnread ? 'orange' : 'gray'}
                            onClick={handleBellClick}
                            title="Comunicados"
                        >
                            <UI.Icon name="notification" />
                        </IconButton>
                        {hasUnread && (
                            <Box
                                position="absolute"
                                top="3px"
                                right="3px"
                                w="7px"
                                h="7px"
                                borderRadius="full"
                                bg="orange.500"
                                pointerEvents="none"
                                css={{
                                    '@keyframes announcePulse': {
                                        '0%, 100%': { transform: 'scale(1)', opacity: 1 },
                                        '50%': { transform: 'scale(1.7)', opacity: 0.45 },
                                    },
                                    animation: 'announcePulse 1.8s ease-in-out infinite',
                                }}
                            />
                        )}
                    </Box>
                    <IconButton size="xs" variant="ghost" colorPalette="orange" children={<UI.Icon name={colorMode.colorMode} />} onClick={colorMode.toggleColorMode} />
                    <IconButton size="xs" variant="ghost" colorPalette="red" children={<UI.Icon name="logout" />} onClick={handleLogout} />
                </ButtonGroup>
            </Box>
        </Flex>
    </Box>

    <UI.Show visible={!!distributor.data && !distributor.data?.options?.terms}><DialogTerms /></UI.Show>

    {announcement && (
        <UI.Dialog open title={announcement.title} onClose={() => setAnnouncement(null)} size="lg">
            <DialogBody pb={4}>
                <Image src={announcement.image} maxH="75vh" w="100%" objectFit="contain" borderRadius={8} alt={announcement.title} />
            </DialogBody>
        </UI.Dialog>
    )}
    </>
    )
}


const DialogTerms = ({ open = false }) => {

    const distributor = useDistributor()
    const [ loading, setLoading ] = useState(false)

    const handleAccept = async () => {
        setLoading(true)

        try{
            await API.post('/terms')
            toaster.create({ title: 'Termos de utilização aceitos com sucesso. Seja bem vindo(a)!', type: 'success' })
            distributor.refetch()
        }catch(err){
            toaster.create({ title: 'Não foi possível continuar agora. Tente novamente', type: 'error' })
        }

        setLoading(false)
    }

    return(
    <UI.Dialog open title="Termos de Utilização do Escritório de Núcleos">
        <DialogBody>
            <Stack>
                <Text>Para continuar a utilização do seu novo escritório de núcleos, antes você deve confirmar que leu e concorda com o <b>Contrato de Núcleo Regional</b> da Bonífica.</Text>

                <Separator />

                <UI.Terms />
            </Stack>
        </DialogBody>
        <DialogFooter>
            <ButtonGroup>
                <Button colorPalette="green" loading={loading} loadingText="Salvando assinatura..." onClick={handleAccept}><UI.Icon name="check" />Confirmo que li e concordo com os termos</Button>
                <Button disabled={loading} variant="ghost" colorPalette="red"><UI.Icon name="logout" /> Sair</Button>
            </ButtonGroup>
        </DialogFooter>
    </UI.Dialog>
    )
}